module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/logo_visadebito.ed193bb5.png";